<script setup>
import {ref} from "vue";
import AddWebsiteFormStep1 from "@/components/website/single/AddWebsiteFormStep1.vue";
import AddWebsiteFormStep2 from "@/components/website/single/AddWebsiteFormStep2.vue";

defineProps({
  countries: {
    required: true,
    type: Object,
  },
  industries: {
    required: true,
    type: Object,
  },
  merchantName: {
    required: true,
    type: String,
  },
  whitelabelSetupCheck: {
    required: true,
    type: Boolean,
  },
});

const currentStep = ref(1);

const handleNext = () => currentStep.value++;
const handleBack = () => currentStep.value--;
</script>

<template>
  <div class="tw-mx-auto tw-max-w-default-container tw-text-center tw-py-6">
    <div
      v-if="whitelabelSetupCheck"
      class="tw-w-full tw-mb-10"
    >
      <div class="tw-text-center tw-p-5 tw-border-dashed tw-border-2 tw-border-denali-dark">
        <div class="tw-text-3xl tw-text-slate-100 tw-font-bold">
          Looking to white-label Hike?
        </div>

        <p class="tw-leading-8">
          Update your white-label settings to setup your branding, custom domain name, live chat
          support and custom CSS.
        </p>
        <p class="tw-leading-8">
          To setup these settings you just need to click on the
          <a
            href="/settings"
            class="btn btn-default btn-sm"
          >
            <i class="fad fa-tags text-dark xs-mr-5" /> white-label
          </a>
          button in the navigation bar above.
        </p>
      </div>
    </div>
  </div>

  <AddWebsiteFormStep1
    v-if="currentStep === 1"
    :merchantName="merchantName"
    @next="handleNext"
  />

  <AddWebsiteFormStep2
    v-else-if="currentStep === 2"
    :countries="countries"
    :industries="industries"
    @next="handleNext"
    @back="handleBack"
  />
</template>
